/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as LogoutRouteRouteImport } from './routes/logout/route'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as ForgotpasswordRouteRouteImport } from './routes/forgotpassword/route'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedPcRouteRouteImport } from './routes/_protected/pc/route'
import { Route as ProtectedLocation_lookupRouteRouteImport } from './routes/_protected/location_lookup/route'
import { Route as ProtectedIndustriesRouteRouteImport } from './routes/_protected/industries/route'
import { Route as ProtectedEbRouteRouteImport } from './routes/_protected/eb/route'
import { Route as ProtectedResultsIndexRouteImport } from './routes/_protected/results/index'
import { Route as ProtectedEbIndexRouteImport } from './routes/_protected/eb/index'
import { Route as ProtectedAlternateAddressesMunsRouteImport } from './routes/_protected/alternate-addresses/$muns'
import { Route as ProtectedWhdDetailsMunsRouteRouteImport } from './routes/_protected/whd-details/$muns/route'
import { Route as ProtectedStatisticsPcRouteRouteImport } from './routes/_protected/statistics/pc/route'
import { Route as ProtectedStatisticsEbRouteRouteImport } from './routes/_protected/statistics/eb/route'
import { Route as ProtectedResultsPcRouteRouteImport } from './routes/_protected/results/pc/route'
import { Route as ProtectedResultsEbRouteRouteImport } from './routes/_protected/results/eb/route'
import { Route as ProtectedResultsDashboardRouteRouteImport } from './routes/_protected/results/dashboard/route'
import { Route as ProtectedOshaDetails2MunsRouteRouteImport } from './routes/_protected/osha-details2/$muns/route'
import { Route as ProtectedOshaDetailsMunsRouteRouteImport } from './routes/_protected/osha-details/$muns/route'
import { Route as ProtectedMyaccountModuleRouteRouteImport } from './routes/_protected/myaccount/$module/route'
import { Route as ProtectedDotDetailsMunsRouteRouteImport } from './routes/_protected/dot-details/$muns/route'
import { Route as ProtectedModuleTrack_exportsRouteRouteImport } from './routes/_protected/$module/track_exports/route'
import { Route as ProtectedModuleSavedsearchesRouteRouteImport } from './routes/_protected/$module/savedsearches/route'
import { Route as ProtectedModuleFavoritesRouteRouteImport } from './routes/_protected/$module/favorites/route'
import { Route as ProtectedModuleEvent_alertsRouteRouteImport } from './routes/_protected/$module/event_alerts/route'
import { Route as ProtectedResultsDashboardIndexRouteImport } from './routes/_protected/results/dashboard/index'
import { Route as ProtectedResultsDashboardMunsRouteRouteImport } from './routes/_protected/results/dashboard/$muns/route'
import { Route as ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRouteImport } from './routes/_protected/event_alerts_details/$muns/$subscription_ids/route'
import { Route as ProtectedEbBrokerMsidRouteRouteImport } from './routes/_protected/eb/broker/$msid/route'
import { Route as ProtectedAlternateAddressesModuleMunsRouteRouteImport } from './routes/_protected/alternate-addresses/$module/$muns/route'

const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRouteRoute = LogoutRouteRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/logout/route.lazy').then((d) => d.Route))
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login/route.lazy').then((d) => d.Route))
const ForgotpasswordRouteRoute = ForgotpasswordRouteRouteImport.update({
  id: '/forgotpassword',
  path: '/forgotpassword',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forgotpassword/route.lazy').then((d) => d.Route),
)
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedPcRouteRoute = ProtectedPcRouteRouteImport.update({
  id: '/pc',
  path: '/pc',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/pc/route.lazy').then((d) => d.Route),
)
const ProtectedLocation_lookupRouteRoute =
  ProtectedLocation_lookupRouteRouteImport.update({
    id: '/location_lookup',
    path: '/location_lookup',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/location_lookup/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedIndustriesRouteRoute =
  ProtectedIndustriesRouteRouteImport.update({
    id: '/industries',
    path: '/industries',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/industries/route.lazy').then((d) => d.Route),
  )
const ProtectedEbRouteRoute = ProtectedEbRouteRouteImport.update({
  id: '/eb',
  path: '/eb',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedResultsIndexRoute = ProtectedResultsIndexRouteImport.update({
  id: '/results/',
  path: '/results/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedEbIndexRoute = ProtectedEbIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedEbRouteRoute,
} as any).lazy(() =>
  import('./routes/_protected/eb/index.lazy').then((d) => d.Route),
)
const ProtectedAlternateAddressesMunsRoute =
  ProtectedAlternateAddressesMunsRouteImport.update({
    id: '/alternate-addresses/$muns',
    path: '/alternate-addresses/$muns',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedWhdDetailsMunsRouteRoute =
  ProtectedWhdDetailsMunsRouteRouteImport.update({
    id: '/whd-details/$muns',
    path: '/whd-details/$muns',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/whd-details/$muns/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedStatisticsPcRouteRoute =
  ProtectedStatisticsPcRouteRouteImport.update({
    id: '/statistics/pc',
    path: '/statistics/pc',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/statistics/pc/route.lazy').then((d) => d.Route),
  )
const ProtectedStatisticsEbRouteRoute =
  ProtectedStatisticsEbRouteRouteImport.update({
    id: '/statistics/eb',
    path: '/statistics/eb',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/statistics/eb/route.lazy').then((d) => d.Route),
  )
const ProtectedResultsPcRouteRoute = ProtectedResultsPcRouteRouteImport.update({
  id: '/results/pc',
  path: '/results/pc',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/results/pc/route.lazy').then((d) => d.Route),
)
const ProtectedResultsEbRouteRoute = ProtectedResultsEbRouteRouteImport.update({
  id: '/results/eb',
  path: '/results/eb',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/results/eb/route.lazy').then((d) => d.Route),
)
const ProtectedResultsDashboardRouteRoute =
  ProtectedResultsDashboardRouteRouteImport.update({
    id: '/results/dashboard',
    path: '/results/dashboard',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedOshaDetails2MunsRouteRoute =
  ProtectedOshaDetails2MunsRouteRouteImport.update({
    id: '/osha-details2/$muns',
    path: '/osha-details2/$muns',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/osha-details2/$muns/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedOshaDetailsMunsRouteRoute =
  ProtectedOshaDetailsMunsRouteRouteImport.update({
    id: '/osha-details/$muns',
    path: '/osha-details/$muns',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/osha-details/$muns/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedMyaccountModuleRouteRoute =
  ProtectedMyaccountModuleRouteRouteImport.update({
    id: '/myaccount/$module',
    path: '/myaccount/$module',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/myaccount/$module/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedDotDetailsMunsRouteRoute =
  ProtectedDotDetailsMunsRouteRouteImport.update({
    id: '/dot-details/$muns',
    path: '/dot-details/$muns',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/dot-details/$muns/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedModuleTrack_exportsRouteRoute =
  ProtectedModuleTrack_exportsRouteRouteImport.update({
    id: '/$module/track_exports',
    path: '/$module/track_exports',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$module/track_exports/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedModuleSavedsearchesRouteRoute =
  ProtectedModuleSavedsearchesRouteRouteImport.update({
    id: '/$module/savedsearches',
    path: '/$module/savedsearches',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$module/savedsearches/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedModuleFavoritesRouteRoute =
  ProtectedModuleFavoritesRouteRouteImport.update({
    id: '/$module/favorites',
    path: '/$module/favorites',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$module/favorites/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedModuleEvent_alertsRouteRoute =
  ProtectedModuleEvent_alertsRouteRouteImport.update({
    id: '/$module/event_alerts',
    path: '/$module/event_alerts',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/$module/event_alerts/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedResultsDashboardIndexRoute =
  ProtectedResultsDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedResultsDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/results/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedResultsDashboardMunsRouteRoute =
  ProtectedResultsDashboardMunsRouteRouteImport.update({
    id: '/$muns',
    path: '/$muns',
    getParentRoute: () => ProtectedResultsDashboardRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/results/dashboard/$muns/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute =
  ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRouteImport.update({
    id: '/event_alerts_details/$muns/$subscription_ids',
    path: '/event_alerts_details/$muns/$subscription_ids',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/event_alerts_details/$muns/$subscription_ids/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedEbBrokerMsidRouteRoute =
  ProtectedEbBrokerMsidRouteRouteImport.update({
    id: '/broker/$msid',
    path: '/broker/$msid',
    getParentRoute: () => ProtectedEbRouteRoute,
  } as any).lazy(() =>
    import('./routes/_protected/eb/broker/$msid/route.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedAlternateAddressesModuleMunsRouteRoute =
  ProtectedAlternateAddressesModuleMunsRouteRouteImport.update({
    id: '/alternate-addresses/$module/$muns',
    path: '/alternate-addresses/$module/$muns',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/alternate-addresses/$module/$muns/route.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/forgotpassword': typeof ForgotpasswordRouteRoute
  '/login': typeof LoginRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/': typeof ProtectedIndexRoute
  '/error': typeof ErrorRoute
  '/forbidden': typeof ForbiddenRoute
  '/eb': typeof ProtectedEbRouteRouteWithChildren
  '/industries': typeof ProtectedIndustriesRouteRoute
  '/location_lookup': typeof ProtectedLocation_lookupRouteRoute
  '/pc': typeof ProtectedPcRouteRoute
  '/$module/event_alerts': typeof ProtectedModuleEvent_alertsRouteRoute
  '/$module/favorites': typeof ProtectedModuleFavoritesRouteRoute
  '/$module/savedsearches': typeof ProtectedModuleSavedsearchesRouteRoute
  '/$module/track_exports': typeof ProtectedModuleTrack_exportsRouteRoute
  '/dot-details/$muns': typeof ProtectedDotDetailsMunsRouteRoute
  '/myaccount/$module': typeof ProtectedMyaccountModuleRouteRoute
  '/osha-details/$muns': typeof ProtectedOshaDetailsMunsRouteRoute
  '/osha-details2/$muns': typeof ProtectedOshaDetails2MunsRouteRoute
  '/results/dashboard': typeof ProtectedResultsDashboardRouteRouteWithChildren
  '/results/eb': typeof ProtectedResultsEbRouteRoute
  '/results/pc': typeof ProtectedResultsPcRouteRoute
  '/statistics/eb': typeof ProtectedStatisticsEbRouteRoute
  '/statistics/pc': typeof ProtectedStatisticsPcRouteRoute
  '/whd-details/$muns': typeof ProtectedWhdDetailsMunsRouteRoute
  '/alternate-addresses/$muns': typeof ProtectedAlternateAddressesMunsRoute
  '/eb/': typeof ProtectedEbIndexRoute
  '/results/': typeof ProtectedResultsIndexRoute
  '/alternate-addresses/$module/$muns': typeof ProtectedAlternateAddressesModuleMunsRouteRoute
  '/eb/broker/$msid': typeof ProtectedEbBrokerMsidRouteRoute
  '/event_alerts_details/$muns/$subscription_ids': typeof ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute
  '/results/dashboard/$muns': typeof ProtectedResultsDashboardMunsRouteRoute
  '/results/dashboard/': typeof ProtectedResultsDashboardIndexRoute
}
export interface FileRoutesByTo {
  '/forgotpassword': typeof ForgotpasswordRouteRoute
  '/login': typeof LoginRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/error': typeof ErrorRoute
  '/forbidden': typeof ForbiddenRoute
  '/industries': typeof ProtectedIndustriesRouteRoute
  '/location_lookup': typeof ProtectedLocation_lookupRouteRoute
  '/pc': typeof ProtectedPcRouteRoute
  '/': typeof ProtectedIndexRoute
  '/$module/event_alerts': typeof ProtectedModuleEvent_alertsRouteRoute
  '/$module/favorites': typeof ProtectedModuleFavoritesRouteRoute
  '/$module/savedsearches': typeof ProtectedModuleSavedsearchesRouteRoute
  '/$module/track_exports': typeof ProtectedModuleTrack_exportsRouteRoute
  '/dot-details/$muns': typeof ProtectedDotDetailsMunsRouteRoute
  '/myaccount/$module': typeof ProtectedMyaccountModuleRouteRoute
  '/osha-details/$muns': typeof ProtectedOshaDetailsMunsRouteRoute
  '/osha-details2/$muns': typeof ProtectedOshaDetails2MunsRouteRoute
  '/results/eb': typeof ProtectedResultsEbRouteRoute
  '/results/pc': typeof ProtectedResultsPcRouteRoute
  '/statistics/eb': typeof ProtectedStatisticsEbRouteRoute
  '/statistics/pc': typeof ProtectedStatisticsPcRouteRoute
  '/whd-details/$muns': typeof ProtectedWhdDetailsMunsRouteRoute
  '/alternate-addresses/$muns': typeof ProtectedAlternateAddressesMunsRoute
  '/eb': typeof ProtectedEbIndexRoute
  '/results': typeof ProtectedResultsIndexRoute
  '/alternate-addresses/$module/$muns': typeof ProtectedAlternateAddressesModuleMunsRouteRoute
  '/eb/broker/$msid': typeof ProtectedEbBrokerMsidRouteRoute
  '/event_alerts_details/$muns/$subscription_ids': typeof ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute
  '/results/dashboard/$muns': typeof ProtectedResultsDashboardMunsRouteRoute
  '/results/dashboard': typeof ProtectedResultsDashboardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/forgotpassword': typeof ForgotpasswordRouteRoute
  '/login': typeof LoginRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/error': typeof ErrorRoute
  '/forbidden': typeof ForbiddenRoute
  '/_protected/eb': typeof ProtectedEbRouteRouteWithChildren
  '/_protected/industries': typeof ProtectedIndustriesRouteRoute
  '/_protected/location_lookup': typeof ProtectedLocation_lookupRouteRoute
  '/_protected/pc': typeof ProtectedPcRouteRoute
  '/_protected/': typeof ProtectedIndexRoute
  '/_protected/$module/event_alerts': typeof ProtectedModuleEvent_alertsRouteRoute
  '/_protected/$module/favorites': typeof ProtectedModuleFavoritesRouteRoute
  '/_protected/$module/savedsearches': typeof ProtectedModuleSavedsearchesRouteRoute
  '/_protected/$module/track_exports': typeof ProtectedModuleTrack_exportsRouteRoute
  '/_protected/dot-details/$muns': typeof ProtectedDotDetailsMunsRouteRoute
  '/_protected/myaccount/$module': typeof ProtectedMyaccountModuleRouteRoute
  '/_protected/osha-details/$muns': typeof ProtectedOshaDetailsMunsRouteRoute
  '/_protected/osha-details2/$muns': typeof ProtectedOshaDetails2MunsRouteRoute
  '/_protected/results/dashboard': typeof ProtectedResultsDashboardRouteRouteWithChildren
  '/_protected/results/eb': typeof ProtectedResultsEbRouteRoute
  '/_protected/results/pc': typeof ProtectedResultsPcRouteRoute
  '/_protected/statistics/eb': typeof ProtectedStatisticsEbRouteRoute
  '/_protected/statistics/pc': typeof ProtectedStatisticsPcRouteRoute
  '/_protected/whd-details/$muns': typeof ProtectedWhdDetailsMunsRouteRoute
  '/_protected/alternate-addresses/$muns': typeof ProtectedAlternateAddressesMunsRoute
  '/_protected/eb/': typeof ProtectedEbIndexRoute
  '/_protected/results/': typeof ProtectedResultsIndexRoute
  '/_protected/alternate-addresses/$module/$muns': typeof ProtectedAlternateAddressesModuleMunsRouteRoute
  '/_protected/eb/broker/$msid': typeof ProtectedEbBrokerMsidRouteRoute
  '/_protected/event_alerts_details/$muns/$subscription_ids': typeof ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute
  '/_protected/results/dashboard/$muns': typeof ProtectedResultsDashboardMunsRouteRoute
  '/_protected/results/dashboard/': typeof ProtectedResultsDashboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forgotpassword'
    | '/login'
    | '/logout'
    | '/'
    | '/error'
    | '/forbidden'
    | '/eb'
    | '/industries'
    | '/location_lookup'
    | '/pc'
    | '/$module/event_alerts'
    | '/$module/favorites'
    | '/$module/savedsearches'
    | '/$module/track_exports'
    | '/dot-details/$muns'
    | '/myaccount/$module'
    | '/osha-details/$muns'
    | '/osha-details2/$muns'
    | '/results/dashboard'
    | '/results/eb'
    | '/results/pc'
    | '/statistics/eb'
    | '/statistics/pc'
    | '/whd-details/$muns'
    | '/alternate-addresses/$muns'
    | '/eb/'
    | '/results/'
    | '/alternate-addresses/$module/$muns'
    | '/eb/broker/$msid'
    | '/event_alerts_details/$muns/$subscription_ids'
    | '/results/dashboard/$muns'
    | '/results/dashboard/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgotpassword'
    | '/login'
    | '/logout'
    | '/error'
    | '/forbidden'
    | '/industries'
    | '/location_lookup'
    | '/pc'
    | '/'
    | '/$module/event_alerts'
    | '/$module/favorites'
    | '/$module/savedsearches'
    | '/$module/track_exports'
    | '/dot-details/$muns'
    | '/myaccount/$module'
    | '/osha-details/$muns'
    | '/osha-details2/$muns'
    | '/results/eb'
    | '/results/pc'
    | '/statistics/eb'
    | '/statistics/pc'
    | '/whd-details/$muns'
    | '/alternate-addresses/$muns'
    | '/eb'
    | '/results'
    | '/alternate-addresses/$module/$muns'
    | '/eb/broker/$msid'
    | '/event_alerts_details/$muns/$subscription_ids'
    | '/results/dashboard/$muns'
    | '/results/dashboard'
  id:
    | '__root__'
    | '/forgotpassword'
    | '/login'
    | '/logout'
    | '/_protected'
    | '/error'
    | '/forbidden'
    | '/_protected/eb'
    | '/_protected/industries'
    | '/_protected/location_lookup'
    | '/_protected/pc'
    | '/_protected/'
    | '/_protected/$module/event_alerts'
    | '/_protected/$module/favorites'
    | '/_protected/$module/savedsearches'
    | '/_protected/$module/track_exports'
    | '/_protected/dot-details/$muns'
    | '/_protected/myaccount/$module'
    | '/_protected/osha-details/$muns'
    | '/_protected/osha-details2/$muns'
    | '/_protected/results/dashboard'
    | '/_protected/results/eb'
    | '/_protected/results/pc'
    | '/_protected/statistics/eb'
    | '/_protected/statistics/pc'
    | '/_protected/whd-details/$muns'
    | '/_protected/alternate-addresses/$muns'
    | '/_protected/eb/'
    | '/_protected/results/'
    | '/_protected/alternate-addresses/$module/$muns'
    | '/_protected/eb/broker/$msid'
    | '/_protected/event_alerts_details/$muns/$subscription_ids'
    | '/_protected/results/dashboard/$muns'
    | '/_protected/results/dashboard/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ForgotpasswordRouteRoute: typeof ForgotpasswordRouteRoute
  LoginRouteRoute: typeof LoginRouteRoute
  LogoutRouteRoute: typeof LogoutRouteRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  ForbiddenRoute: typeof ForbiddenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgotpassword': {
      id: '/forgotpassword'
      path: '/forgotpassword'
      fullPath: '/forgotpassword'
      preLoaderRoute: typeof ForgotpasswordRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/': {
      id: '/_protected/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/pc': {
      id: '/_protected/pc'
      path: '/pc'
      fullPath: '/pc'
      preLoaderRoute: typeof ProtectedPcRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/location_lookup': {
      id: '/_protected/location_lookup'
      path: '/location_lookup'
      fullPath: '/location_lookup'
      preLoaderRoute: typeof ProtectedLocation_lookupRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/industries': {
      id: '/_protected/industries'
      path: '/industries'
      fullPath: '/industries'
      preLoaderRoute: typeof ProtectedIndustriesRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/eb': {
      id: '/_protected/eb'
      path: '/eb'
      fullPath: '/eb'
      preLoaderRoute: typeof ProtectedEbRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/results/': {
      id: '/_protected/results/'
      path: '/results'
      fullPath: '/results/'
      preLoaderRoute: typeof ProtectedResultsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/eb/': {
      id: '/_protected/eb/'
      path: '/'
      fullPath: '/eb/'
      preLoaderRoute: typeof ProtectedEbIndexRouteImport
      parentRoute: typeof ProtectedEbRouteRoute
    }
    '/_protected/alternate-addresses/$muns': {
      id: '/_protected/alternate-addresses/$muns'
      path: '/alternate-addresses/$muns'
      fullPath: '/alternate-addresses/$muns'
      preLoaderRoute: typeof ProtectedAlternateAddressesMunsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/whd-details/$muns': {
      id: '/_protected/whd-details/$muns'
      path: '/whd-details/$muns'
      fullPath: '/whd-details/$muns'
      preLoaderRoute: typeof ProtectedWhdDetailsMunsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/statistics/pc': {
      id: '/_protected/statistics/pc'
      path: '/statistics/pc'
      fullPath: '/statistics/pc'
      preLoaderRoute: typeof ProtectedStatisticsPcRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/statistics/eb': {
      id: '/_protected/statistics/eb'
      path: '/statistics/eb'
      fullPath: '/statistics/eb'
      preLoaderRoute: typeof ProtectedStatisticsEbRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/results/pc': {
      id: '/_protected/results/pc'
      path: '/results/pc'
      fullPath: '/results/pc'
      preLoaderRoute: typeof ProtectedResultsPcRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/results/eb': {
      id: '/_protected/results/eb'
      path: '/results/eb'
      fullPath: '/results/eb'
      preLoaderRoute: typeof ProtectedResultsEbRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/results/dashboard': {
      id: '/_protected/results/dashboard'
      path: '/results/dashboard'
      fullPath: '/results/dashboard'
      preLoaderRoute: typeof ProtectedResultsDashboardRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/osha-details2/$muns': {
      id: '/_protected/osha-details2/$muns'
      path: '/osha-details2/$muns'
      fullPath: '/osha-details2/$muns'
      preLoaderRoute: typeof ProtectedOshaDetails2MunsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/osha-details/$muns': {
      id: '/_protected/osha-details/$muns'
      path: '/osha-details/$muns'
      fullPath: '/osha-details/$muns'
      preLoaderRoute: typeof ProtectedOshaDetailsMunsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/myaccount/$module': {
      id: '/_protected/myaccount/$module'
      path: '/myaccount/$module'
      fullPath: '/myaccount/$module'
      preLoaderRoute: typeof ProtectedMyaccountModuleRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dot-details/$muns': {
      id: '/_protected/dot-details/$muns'
      path: '/dot-details/$muns'
      fullPath: '/dot-details/$muns'
      preLoaderRoute: typeof ProtectedDotDetailsMunsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$module/track_exports': {
      id: '/_protected/$module/track_exports'
      path: '/$module/track_exports'
      fullPath: '/$module/track_exports'
      preLoaderRoute: typeof ProtectedModuleTrack_exportsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$module/savedsearches': {
      id: '/_protected/$module/savedsearches'
      path: '/$module/savedsearches'
      fullPath: '/$module/savedsearches'
      preLoaderRoute: typeof ProtectedModuleSavedsearchesRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$module/favorites': {
      id: '/_protected/$module/favorites'
      path: '/$module/favorites'
      fullPath: '/$module/favorites'
      preLoaderRoute: typeof ProtectedModuleFavoritesRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/$module/event_alerts': {
      id: '/_protected/$module/event_alerts'
      path: '/$module/event_alerts'
      fullPath: '/$module/event_alerts'
      preLoaderRoute: typeof ProtectedModuleEvent_alertsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/results/dashboard/': {
      id: '/_protected/results/dashboard/'
      path: '/'
      fullPath: '/results/dashboard/'
      preLoaderRoute: typeof ProtectedResultsDashboardIndexRouteImport
      parentRoute: typeof ProtectedResultsDashboardRouteRoute
    }
    '/_protected/results/dashboard/$muns': {
      id: '/_protected/results/dashboard/$muns'
      path: '/$muns'
      fullPath: '/results/dashboard/$muns'
      preLoaderRoute: typeof ProtectedResultsDashboardMunsRouteRouteImport
      parentRoute: typeof ProtectedResultsDashboardRouteRoute
    }
    '/_protected/event_alerts_details/$muns/$subscription_ids': {
      id: '/_protected/event_alerts_details/$muns/$subscription_ids'
      path: '/event_alerts_details/$muns/$subscription_ids'
      fullPath: '/event_alerts_details/$muns/$subscription_ids'
      preLoaderRoute: typeof ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/eb/broker/$msid': {
      id: '/_protected/eb/broker/$msid'
      path: '/broker/$msid'
      fullPath: '/eb/broker/$msid'
      preLoaderRoute: typeof ProtectedEbBrokerMsidRouteRouteImport
      parentRoute: typeof ProtectedEbRouteRoute
    }
    '/_protected/alternate-addresses/$module/$muns': {
      id: '/_protected/alternate-addresses/$module/$muns'
      path: '/alternate-addresses/$module/$muns'
      fullPath: '/alternate-addresses/$module/$muns'
      preLoaderRoute: typeof ProtectedAlternateAddressesModuleMunsRouteRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedEbRouteRouteChildren {
  ProtectedEbIndexRoute: typeof ProtectedEbIndexRoute
  ProtectedEbBrokerMsidRouteRoute: typeof ProtectedEbBrokerMsidRouteRoute
}

const ProtectedEbRouteRouteChildren: ProtectedEbRouteRouteChildren = {
  ProtectedEbIndexRoute: ProtectedEbIndexRoute,
  ProtectedEbBrokerMsidRouteRoute: ProtectedEbBrokerMsidRouteRoute,
}

const ProtectedEbRouteRouteWithChildren =
  ProtectedEbRouteRoute._addFileChildren(ProtectedEbRouteRouteChildren)

interface ProtectedResultsDashboardRouteRouteChildren {
  ProtectedResultsDashboardMunsRouteRoute: typeof ProtectedResultsDashboardMunsRouteRoute
  ProtectedResultsDashboardIndexRoute: typeof ProtectedResultsDashboardIndexRoute
}

const ProtectedResultsDashboardRouteRouteChildren: ProtectedResultsDashboardRouteRouteChildren =
  {
    ProtectedResultsDashboardMunsRouteRoute:
      ProtectedResultsDashboardMunsRouteRoute,
    ProtectedResultsDashboardIndexRoute: ProtectedResultsDashboardIndexRoute,
  }

const ProtectedResultsDashboardRouteRouteWithChildren =
  ProtectedResultsDashboardRouteRoute._addFileChildren(
    ProtectedResultsDashboardRouteRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedEbRouteRoute: typeof ProtectedEbRouteRouteWithChildren
  ProtectedIndustriesRouteRoute: typeof ProtectedIndustriesRouteRoute
  ProtectedLocation_lookupRouteRoute: typeof ProtectedLocation_lookupRouteRoute
  ProtectedPcRouteRoute: typeof ProtectedPcRouteRoute
  ProtectedIndexRoute: typeof ProtectedIndexRoute
  ProtectedModuleEvent_alertsRouteRoute: typeof ProtectedModuleEvent_alertsRouteRoute
  ProtectedModuleFavoritesRouteRoute: typeof ProtectedModuleFavoritesRouteRoute
  ProtectedModuleSavedsearchesRouteRoute: typeof ProtectedModuleSavedsearchesRouteRoute
  ProtectedModuleTrack_exportsRouteRoute: typeof ProtectedModuleTrack_exportsRouteRoute
  ProtectedDotDetailsMunsRouteRoute: typeof ProtectedDotDetailsMunsRouteRoute
  ProtectedMyaccountModuleRouteRoute: typeof ProtectedMyaccountModuleRouteRoute
  ProtectedOshaDetailsMunsRouteRoute: typeof ProtectedOshaDetailsMunsRouteRoute
  ProtectedOshaDetails2MunsRouteRoute: typeof ProtectedOshaDetails2MunsRouteRoute
  ProtectedResultsDashboardRouteRoute: typeof ProtectedResultsDashboardRouteRouteWithChildren
  ProtectedResultsEbRouteRoute: typeof ProtectedResultsEbRouteRoute
  ProtectedResultsPcRouteRoute: typeof ProtectedResultsPcRouteRoute
  ProtectedStatisticsEbRouteRoute: typeof ProtectedStatisticsEbRouteRoute
  ProtectedStatisticsPcRouteRoute: typeof ProtectedStatisticsPcRouteRoute
  ProtectedWhdDetailsMunsRouteRoute: typeof ProtectedWhdDetailsMunsRouteRoute
  ProtectedAlternateAddressesMunsRoute: typeof ProtectedAlternateAddressesMunsRoute
  ProtectedResultsIndexRoute: typeof ProtectedResultsIndexRoute
  ProtectedAlternateAddressesModuleMunsRouteRoute: typeof ProtectedAlternateAddressesModuleMunsRouteRoute
  ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute: typeof ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedEbRouteRoute: ProtectedEbRouteRouteWithChildren,
  ProtectedIndustriesRouteRoute: ProtectedIndustriesRouteRoute,
  ProtectedLocation_lookupRouteRoute: ProtectedLocation_lookupRouteRoute,
  ProtectedPcRouteRoute: ProtectedPcRouteRoute,
  ProtectedIndexRoute: ProtectedIndexRoute,
  ProtectedModuleEvent_alertsRouteRoute: ProtectedModuleEvent_alertsRouteRoute,
  ProtectedModuleFavoritesRouteRoute: ProtectedModuleFavoritesRouteRoute,
  ProtectedModuleSavedsearchesRouteRoute:
    ProtectedModuleSavedsearchesRouteRoute,
  ProtectedModuleTrack_exportsRouteRoute:
    ProtectedModuleTrack_exportsRouteRoute,
  ProtectedDotDetailsMunsRouteRoute: ProtectedDotDetailsMunsRouteRoute,
  ProtectedMyaccountModuleRouteRoute: ProtectedMyaccountModuleRouteRoute,
  ProtectedOshaDetailsMunsRouteRoute: ProtectedOshaDetailsMunsRouteRoute,
  ProtectedOshaDetails2MunsRouteRoute: ProtectedOshaDetails2MunsRouteRoute,
  ProtectedResultsDashboardRouteRoute:
    ProtectedResultsDashboardRouteRouteWithChildren,
  ProtectedResultsEbRouteRoute: ProtectedResultsEbRouteRoute,
  ProtectedResultsPcRouteRoute: ProtectedResultsPcRouteRoute,
  ProtectedStatisticsEbRouteRoute: ProtectedStatisticsEbRouteRoute,
  ProtectedStatisticsPcRouteRoute: ProtectedStatisticsPcRouteRoute,
  ProtectedWhdDetailsMunsRouteRoute: ProtectedWhdDetailsMunsRouteRoute,
  ProtectedAlternateAddressesMunsRoute: ProtectedAlternateAddressesMunsRoute,
  ProtectedResultsIndexRoute: ProtectedResultsIndexRoute,
  ProtectedAlternateAddressesModuleMunsRouteRoute:
    ProtectedAlternateAddressesModuleMunsRouteRoute,
  ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute:
    ProtectedEvent_alerts_detailsMunsSubscription_idsRouteRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ForgotpasswordRouteRoute: ForgotpasswordRouteRoute,
  LoginRouteRoute: LoginRouteRoute,
  LogoutRouteRoute: LogoutRouteRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  ErrorRoute: ErrorRoute,
  ForbiddenRoute: ForbiddenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
